export default __webpack_public_path__ + "assets/images/7.81b926.webp";